// extracted by mini-css-extract-plugin
export var wordContainer = "_se-0";